import jsPDF from "jspdf";
import moment from "moment/moment";
import { calculateTotals } from "./SalesParty";
import logo from "../assests/images/logo2.png";

const ProductHistory = [
  "S.No",
  "Date",
  "Bill No",
  "Amount",
  "Paid",
  "Payment Method",
  "Balance",
  "Details",
];

const BalanceSheetHeaders = [
    "Date",
  "Particulars",
  "Credit",
  "Debit",
  "Balance",
];

export const generateSalesPartyPdf = (
  clickedData,
  errorAlert,
  from_date,
  to_date
) => {
  if (!clickedData) {
    errorAlert("No data available to export.");
    return;
  }

  const hasTransactions =
    clickedData.transactions && clickedData.transactions.length > 0;

  const hasBalanceSheet =
    clickedData.party_wise_balance_sheet_report &&
    clickedData.party_wise_balance_sheet_report.length > 0;

  if (!hasTransactions && !hasBalanceSheet) {
    errorAlert("No report data available.");
    return;
  }

  const { paid: totalPaid, balance: totalBalance } = calculateTotals(
    hasTransactions ? clickedData.transactions : []
  );

  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const startX = 14;
  const endX = pageWidth - 14;
  const center = pageWidth / 2;
  const tableWidth = endX - startX;

  let startY = 10;
  const lineHeight = 7;
  let currentY = startY;

  const drawCell = (x, y, width, height, style = "S") => {
    doc.rect(x, y, width, height, style);
  };

  // ---------- HEADER ----------
  const headerCardHeight = 15;
  const logoSize = 15;
  const headerColor = [30, 58, 138];
  const cardBackgroundColor = [240, 240, 240];
  const cardTextY = currentY + headerCardHeight / 2;

  doc.setFillColor(...cardBackgroundColor);
  drawCell(startX, currentY, tableWidth, headerCardHeight, "F");

  doc.setFontSize(18);
  doc.setFont(undefined, "bold");
  doc.setTextColor(...headerColor);
  doc.text("MKS", center, cardTextY, {
    align: "center",
    baseline: "middle",
  });

  if (logo) {
    const logoX = startX + 2;
    const logoY = currentY + (headerCardHeight - logoSize) / 2;
    doc.addImage(logo, "PNG", logoX, logoY, logoSize, logoSize);
  }

  currentY += headerCardHeight + 4;

  doc.setFontSize(12);
  doc.setFont(undefined, "bold");
  doc.text(
    `Customer Report: ${clickedData.party_name}`,
    center,
    currentY + 6,
    { align: "center" }
  );
  currentY += 14;

  // ---------- FROM/TO DATE ----------
  const formattedFromDate = from_date
    ? moment.utc(from_date, "YYYY-MM-DD").format("DD MMMM YYYY")
    : "-";
  const formattedToDate = to_date
    ? moment.utc(to_date, "YYYY-MM-DD").format("DD MMMM YYYY")
    : "-";

  doc.setFontSize(10);
  doc.setFont(undefined, "bold");
  doc.setTextColor(0, 0, 0);

  if (formattedFromDate !== "-") {
    doc.text("From Date:", startX, currentY);
    doc.setFont(undefined, "normal");
    doc.text(formattedFromDate, startX + 25, currentY);
    currentY += 5;
  }

  if (formattedToDate !== "-") {
    doc.setFont(undefined, "bold");
    doc.text("To Date:", startX, currentY);
    doc.setFont(undefined, "normal");
    doc.text(formattedToDate, startX + 25, currentY);
    currentY += 7;
  }

  // ********************************************************************
  //  1️⃣ TRANSACTIONS REPORT
  // ********************************************************************
  if (hasTransactions) {
    doc.setFontSize(13);
    doc.setFont(undefined, "bold");
    doc.text("TRANSACTION DETAILS", startX, currentY + 2);
    currentY += 8;

    const finalColumnWidths = [12, 23, 25, 20, 20, 30, 20, 25];

    let currentX = startX;

    // HEADER
    doc.setFontSize(9);
    doc.setFont(undefined, "bold");

    for (let i = 0; i < ProductHistory.length; i++) {
      const width = finalColumnWidths[i];
      doc.setFillColor(220, 220, 220);
      doc.rect(currentX, currentY, width, lineHeight, "F");
      drawCell(currentX, currentY, width, lineHeight);

      doc.text(
        ProductHistory[i],
        currentX + width / 2,
        currentY + lineHeight / 2 + 1.5,
        { align: "center" }
      );
      currentX += width;
    }

    currentY += lineHeight;

    // ROWS
    doc.setFontSize(8);
    doc.setFont(undefined, "normal");

    clickedData.transactions.forEach((t, index) => {
      currentX = startX;

      const rowData = [
        index + 1,
        moment(t.date).format("DD/MM/YY"),
        t.receipt_no,
        t.amount,
        t.paid,
        t.payment_method || "-",
        t.balance,
        t.details || "-",
      ];

      rowData.forEach((cell, i) => {
        const width = finalColumnWidths[i];
        drawCell(currentX, currentY, width, lineHeight);

        let align = "left";
        let offset = 2;

        if (i === 0 || i === 2) {
          align = "center";
          offset = width / 2;
        } else if (i >= 3) {
          align = "right";
          offset = width - 2;
        }

        doc.text(
          String(cell),
          currentX + offset,
          currentY + lineHeight / 2 + 1.5,
          { align }
        );

        currentX += width;
      });

      currentY += lineHeight;
    });

    // TOTALS
    const totalTableWidth = finalColumnWidths.reduce((a, b) => a + b, 0);
    const rightAlignX = startX + totalTableWidth;

    currentY += 5;
    doc.setFontSize(10);
    doc.setFont(undefined, "bold");

    doc.text("TOTAL PAID:", rightAlignX - 40, currentY, { align: "right" });
    doc.text(String(totalPaid), rightAlignX, currentY, { align: "right" });

    currentY += lineHeight;

    doc.text("TOTAL BALANCE:", rightAlignX - 40, currentY, { align: "right" });
    doc.text(String(totalBalance), rightAlignX, currentY, {
      align: "right",
    });

    currentY += 10;
  }

  // ********************************************************************
  //  2️⃣ BALANCE SHEET REPORT
  // ********************************************************************
  if (hasBalanceSheet) {
   if (currentY > 250) {
  doc.addPage();
  currentY = 10;
}


    doc.setFontSize(13);
    doc.setFont(undefined, "bold");
    doc.text("SALES PARTY WISE BALANCE SHEET SUMMARY", startX, currentY + 2);

    currentY += 8;

    const bsWidths = [15, 80, 20, 20, 20];
    let currentX = startX;

    // HEADER
    doc.setFontSize(9);
    doc.setFont(undefined, "bold");

    BalanceSheetHeaders.forEach((h, i) => {
      const width = bsWidths[i];

      doc.setFillColor(220, 220, 220);
      doc.rect(currentX, currentY, width, lineHeight, "F");
      drawCell(currentX, currentY, width, lineHeight);
      doc.text(
        h,
        currentX + width / 2,
        currentY + lineHeight / 2 + 1.5,
        { align: "center" }
      );

      currentX += width;
    });

    currentY += lineHeight;

    // ROWS
    doc.setFontSize(7);
    doc.setFont(undefined, "normal");

    clickedData.party_wise_balance_sheet_report.forEach((b, index) => {
      currentX = startX;

      const rowData = [
        b.Date ? moment(b.Date).format("DD/MM/YY") : "-",
        b.Particulars,
        b.Credit,
        b.Debit,
        b.Balance,
      ];

      rowData.forEach((cell, i) => {
        const width = bsWidths[i];
        drawCell(currentX, currentY, width, lineHeight);

        let align = i === 0 ? "center" : i >= 2 ? "right" : "left";
        let offset =
          i === 0 ? width / 2 : i >= 2 ? width - 2 : 2;

        doc.text(
          String(cell),
          currentX + offset,
          currentY + lineHeight / 2 + 1.5,
          { align }
        );

        currentX += width;
      });

      currentY += lineHeight;
    });

    currentY += 10;
  }

  // ********************************************************************
  //  SAVE PDF
  // ********************************************************************
  doc.save(
    `Report_${clickedData.party_name.replace(/\s+/g, "_")}_${moment().format(
      "YYYYMMDD"
    )}.pdf`
  );
};
